module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo18-554718382f8345ecfe8de5b3e326f08d.jpg";